'use client'

import * as Sentry from '@sentry/nextjs'
import NextError from 'next/error'
import { useEffect } from 'react'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
    useEffect(() => {
        Sentry.captureException(error)
    }, [error])

    return (
        <html lang="pt">
            <body>
                {/* O App Router não expõe o status do erro: 0 mostra a mensagem genérica, como sem o statusCode. */}
                <NextError statusCode={0} />
            </body>
        </html>
    )
}
